
export default [
	{path: "/_template_", component: require("./template.vue")},
	{path: "/", component: require("./home.vue")},
	{path: "/about", component: require("./about.vue")},
	{path: "/history", component: require("./history.vue")},
	{path: "/mkpasswd", component: require("./mkpasswd.vue")},
	{path: "/gridcalc", component: require("./gridcalc.vue")},
	{path: "/datauri", component: require("./datauri.vue")},
	{path: "/asciitree", component: require("./asciitree.vue")},
	{path: "/multimentions", component: require("./multimentions.vue")},
	{path: "/zen2han", component: require("./zen2han.vue")},
	{path: "/ratiocalc", component: require("./ratiocalc.vue")},
]



// WEBPACK FOOTER //
// ./src/js/page/index.js